import React, { Component } from "react";
import { isMobileOnly } from "react-device-detect";
import Button from "../../common/components/Button";

import "../../../style/index.css";
import "./govIdTypeSelection.css";

class GovIdTypeSelectionForm extends Component {
  render() {
    const { formRef, submitFormFn } = this.props;
    return (
      <form className="needs-validation" noValidate ref={formRef}>
        <div className="personal-info-wrap">
          <div className="flow-selection-wrap">
            <div className="flow-selection-text">
              <h3>How would you like to get started?</h3>
              <p>
                You’ll take verification photos in real time using your mobile
                device's camera.{" "}
              </p>
              <p>
                You can begin the process directly in your browser or receive a
                link via text.
              </p>
            </div>
            <div className="mobile-flow">
              <Button
                label={
                  isMobileOnly ? "Continue on Browser" : "Continue on Mobile"
                }
                onClickFn={(e) => {
                  submitFormFn(e, isMobileOnly ? "desktop" : "mobile");
                }}
                className="nyl-button"
                type="button"
              />
            </div>
            <div className="desktop-flow">
              {isMobileOnly ? (
                <Button
                  label="Get a Text"
                  onClickFn={(e) => submitFormFn(e, "mobile")}
                  className="continue-with-browser-link nyl-button"
                  type="button"
                />
              ) : null}
            </div>
          </div>
        </div>
      </form>
    );
  }
}

export default GovIdTypeSelectionForm;
